<template>
  <v-col class="getting-started-content">
    <v-row>
      <v-col>
        <docs-hero-banner
          eyebrow="Start Here"
          title="Getting Started"
          description="Start here to understand where to go first and how to complete your first high-value task in iAdOps."
          :meta-items="heroMetaItems"
        />
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12">
        <docs-section-card
          eyebrow="Quick Start"
          title="Recommended First Steps"
          description="These steps cover the fastest path to orienting yourself and validating live work."
          :icon="['fas', 'flag-checkered']"
        >
          <ol class="body-2 mb-0 pl-4">
            <li class="mb-2">
              Open <router-link to="/internal/projects">
                Projects
              </router-link>
              to review active work and status.
            </li>
            <li class="mb-2">
              Use global search to select context (network/team/project) before
              opening delivery reports.
            </li>
            <li>
              Visit <router-link to="/reports/pacing">
                Pacing
              </router-link>
              to validate delivery health and identify next actions.
            </li>
          </ol>

          <template v-slot:actions>
            <docs-callout
              title="Tip"
              color="info"
              :icon="['fas', 'info-circle']"
            >
              If you are not sure which route to open, start from Projects for
              active work and then move into delivery or time views from there.
            </docs-callout>
          </template>
        </docs-section-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <docs-section-card
          title="Need Route-Specific Help?"
          description="Use the route guides for focused help by screen."
          :icon="['fas', 'map-signs']"
        >
          <router-link
            class="body-2"
            to="/docs/guides"
          >
            Open Route Guides
          </router-link>
        </docs-section-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <docs-section-card
          title="Common Concepts"
          description="Learn selected context, project statuses, and role-based behavior."
          :icon="['fas', 'lightbulb']"
        >
          <router-link
            class="body-2"
            to="/docs/concepts"
          >
            Open Concepts & Glossary
          </router-link>
        </docs-section-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'GettingStartedContent',
  components: {
    DocsCallout: () => import('@/docs/components/DocsCallout.vue'),
    DocsHeroBanner: () => import('@/docs/components/DocsHeroBanner.vue'),
    DocsSectionCard: () => import('@/docs/components/DocsSectionCard.vue'),
  },
  computed: {
    heroMetaItems() {
      return [
        { label: 'Audience: All signed-in users', icon: ['fas', 'users'] },
        { label: 'Time: 5 minutes', icon: ['fas', 'clock'] },
        { label: 'Goal: Reach your first live workflow', icon: ['fas', 'bullseye'] },
      ]
    },
  },
}
</script>
